import { LegalPage } from "@/components/LegalPage";

const sections = [
  {
    label: "All Sales Are Final",
    paragraphs: [
      "ALL SALES ARE FINAL. Because our products are digital and delivered instantly, no refunds, returns, exchanges, or cancellations are offered once a purchase is completed. Please review product descriptions carefully before buying.",
    ],
  },
  {
    label: "Chargebacks",
    paragraphs: [
      "By completing a purchase you acknowledge this no-refund policy and agree not to file a chargeback or payment dispute for a successfully delivered digital product. Fraudulent chargebacks on delivered products may be contested with proof of delivery and may result in being barred from future purchases.",
      "If you experience a technical issue accessing your download, contact us at sales@benzthebrand.com and we will make it right.",
    ],
  },
];

export default function Refund() {
  return (
    <LegalPage
      title="Refund & Chargeback Policy"
      updated="2026-07-06"
      sections={sections}
      testId="refund-page"
    />
  );
}
